var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3512 0H10.6667C3.85778 0 0 3.85778 0 10.6667V29.3334C0 36.1422 3.85778 40 10.6667 40H29.3512C36.16 40 40 36.1422 40 29.3334V10.6667C40 3.85778 36.16 0 29.3512 0Z",
    fill: "#1A1F27"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_2627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21.999V27.999C11 29.102 11.897 29.999 13 29.999H19V21.999H11Z",
    fill: "#55E033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21.999V29.999H27C28.103 29.999 29 29.102 29 27.999V21.999H21Z",
    fill: "#698AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15.9989H24.886C25.337 15.7649 25.764 15.4779 26.121 15.1219C27.29 13.9529 27.29 12.0499 26.121 10.8779C24.987 9.74693 23.014 9.74593 21.879 10.8789C20.243 12.5159 20.022 15.5969 20.002 15.9429C20 15.9619 20.01 15.9789 20.01 15.9989H19.99C19.99 15.9799 20 15.9619 19.999 15.9419C19.979 15.5959 19.758 12.5149 18.121 10.8769C16.987 9.74593 15.012 9.74593 13.878 10.8779C12.709 12.0479 12.709 13.9509 13.878 15.1209C14.235 15.4769 14.663 15.7639 15.114 15.9979H12C10.897 15.9979 10 16.8949 10 17.9979V20.9979H19V16.9979H21V20.9979H30V17.9979C30 16.8959 29.103 15.9989 28 15.9989ZM15.293 13.7069C14.903 13.3169 14.903 12.6829 15.293 12.2919C15.481 12.1039 15.732 11.9999 16 11.9999C16.268 11.9999 16.519 12.1039 16.708 12.2919C17.298 12.8819 17.642 13.9399 17.826 14.8229C16.945 14.6389 15.879 14.2929 15.293 13.7069ZM22.174 14.8249C22.358 13.9419 22.702 12.8829 23.292 12.2929C23.481 12.1039 23.733 11.9999 24 11.9999C24.267 11.9999 24.519 12.1039 24.706 12.2909C25.096 12.6819 25.097 13.3169 24.706 13.7069C24.116 14.2979 23.057 14.6419 22.174 14.8249Z",
    fill: "#F68C2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_2627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGift);
export default __webpack_public_path__ + "static/media/dark-gift.074ca1d46c8ceceb2fbf7b579d682a95.svg";
export { ForwardRef as ReactComponent };